import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux/es/exports";
import {useNavigate, useParams} from "react-router-dom";
import FormCurrency from "../../components/currency/FormCurrency";
import {getByCurrenyId, saveCurrency} from "../../services/currecyService";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

const AddCurrencyPage = () => {

    const {id} = useParams();
    const {token} = useSelector((state) => state.user);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const {t} = useTranslation();
    const handleSubmit = async (evt) => {
        setIsLoading(true);
        evt.preventDefault();
        const response = await saveCurrency(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/currency`,
            token,
            {
                id: id ? id : null,
                name: evt.target.name.value.trim(),
                symbol: evt.target.symbol.value.trim(),
                isMain: evt.target.isMain.checked,
            }
        );
        if (response.success) {
            setIsLoading(false);
            navigate("/currency");
            toast.success(id ? t('action.edit_success') : t('action.add_success'), {
                position: "bottom-right",
                autoClose: 3000,
                closeOnClick: true,
                className: "add-success"
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    const fetchDataFunc = async () => {
        const response = await getByCurrenyId(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/currency/${id}`,
            token
        );
        if (response.success) {
            setData([response.data]);
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (id) {
            fetchDataFunc();
        } else {
            return;
        }
    }, []);

    return (
        <>
            <FormCurrency
                handleSubmit={handleSubmit}
                data={data}
                isLoading={isLoading}
            />
        </>
    );
};
export default AddCurrencyPage;
